module.exports = __webpack_public_path__ + "img/consultation_btn01.bc4a28ce.jpg";